<template>
	<CHeaderLayout @show-account-menu="$emit('show-account-menu')">
		<template #title>
			<h1>Referrals</h1>
		</template>

		<main class="organization-settings-referral">
			<OrganizationReferralSettingsView
				:referral-settings="referralSettings"
				:loading="loading"
				@update-referral-info="handleUpdate"
			>
			</OrganizationReferralSettingsView>
		</main>
	</CHeaderLayout>
</template>

<script lang="ts">
	import { defineComponent, onMounted, reactive, ref } from 'vue';
	import { getReferralSettings, updateReferralSettings } from '@cognitoforms/api/services/settings/organization-settings-service';
	import CHeaderLayout from 'src/components/app/HeaderLayout.vue';
	import OrganizationReferralSettingsView from './OrganizationReferralSettingsView.vue';
	import type { ReferralSettingsViewModel } from './ReferralSettingsViewModel';

	export default defineComponent({
		components: {
			CHeaderLayout,
			OrganizationReferralSettingsView
		},
		setup(props, { emit }) {
			onMounted(() => emit('component-loaded'));
			return {
				loading: ref(true),
				referralSettings: reactive<ReferralSettingsViewModel>({
					Referrals: [],
					CanViewReferrals: false,
					CanManageReferralProgram: false,
					IncludeBranding: false,
					ReferralUrl: ''
				})
			};
		},
		head() {
			return {
				title: 'Referrals - Cognito Forms',
				titleTemplate: '%s'
			};
		},
		async mounted() {
			this.loading = true;

			Object.assign(this.referralSettings, await getReferralSettings());

			this.loading = false;
		},
		methods: {
			async handleUpdate(value) {
				await updateReferralSettings(value);
			}
		}
	});
</script>

<style lang="scss">
.organization-settings-referral {
	--content-max-width: 762px;
}
</style>